import styled from 'styled-components';

import { getCDNImageUrl } from '@/helpers/cdn';

import { device, hexToRGB } from '@/styles/helpers';
import { show } from '@/styles/keyframes';

const btnBackground = getCDNImageUrl('/showMoreBtnCover.webp');

export type GridOptions = {
  columns: number;
  columnsTablet: number;
  columnsMobile: number;
  columnsMobileS: number;
  columnGap: number;
  rowGap: number;
};

export const ScGamesGrid = styled.div`
  transition: all ease 0.3s;
  animation: ${show} 1s ease;

  .loading-ellipsis {
    margin-bottom: 24px;
  }
`;

export const ScGamesGridRow = styled.div<GridOptions>`
  display: grid;
  grid-template-columns: ${({ columns }) => `repeat(${columns || 5}, 1fr)`};
  grid-column-gap: ${({ columnGap }) => `${columnGap}px`};
  grid-row-gap: ${({ rowGap }) => `${rowGap}px`};

  @media (${device.tablet}) {
    grid-template-columns: ${({ columnsTablet }) =>
      `repeat(${columnsTablet}, 1fr)`};
  }
  @media (${device.mobile}) {
    grid-template-columns: ${({ columnsMobile }) =>
      `repeat(${columnsMobile}, 1fr)`};
  }
  @media (${device.mobileS}) {
    grid-template-columns: ${({ columnsMobileS }) =>
      `repeat(${columnsMobileS}, 1fr)`};
  }
`;

export interface ScGameItemPlugProps {
  plugGray?: boolean;
  plugBlack?: boolean;
  smallPlugIcon?: boolean;
}

export const ScGameItemPlug = styled.div<ScGameItemPlugProps>`
  width: 100%;
  padding-top: 100%;
  position: relative;
  background: ${({ theme, plugGray, plugBlack }) =>
    plugBlack
      ? theme.blackColor
      : plugGray
        ? theme.grayLightColor
        : theme.gray1Color};
  border-radius: 12px;
  position: relative;

  & > .logo {
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    & > svg {
      width: ${({ smallPlugIcon: smallIcon }) => (smallIcon ? '31px' : '45px')};
      path {
        fill: ${({ theme, plugGray, plugBlack }) =>
          plugBlack
            ? theme.grayLightColor
            : plugGray
              ? hexToRGB(theme.whiteColor, 0.2)
              : theme.grayMegaLightColor};
      }
    }
  }
`;

export interface ScShowMoreBtnProps {
  darkMode: boolean;
  smallShowBtn: boolean;
}

export const ScShowMoreBtn = styled.div<ScShowMoreBtnProps>`
  display: block;
  width: 100%;
  height: 100%;
  padding-top: 100%;
  position: relative;
  background: ${({ theme, darkMode, smallShowBtn }) =>
    smallShowBtn
      ? darkMode
        ? theme.grayLightColor
        : theme.gray1Color
      : `url(${btnBackground}) center no-repeat, ${
          darkMode ? theme.grayLightColor : theme.gray1Color
        }`};
  background-size: cover;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  & > .text-btn,
  & > button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  & > .text-btn {
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.14px;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 0;
    color: ${({ theme, darkMode }) =>
      darkMode ? theme.whiteColor : theme.blackColor};
  }
`;
